import {useDebugValue} from 'react';

import {
    useSubmitDetailsEvents
} from './';

function useSubmitDetails(props) {
    const {
        events
    } = useSubmitDetailsEvents(props);

    const result = {
        events
    };

    useDebugValue(result);

    return result;
}

export {useSubmitDetails};
